
(function($) {
    $('a.lightbox').colorbox({
        rel:true,
        transition: 'fade',
        current: '{current} / {total}',
        slideshow: false,
        maxHeight: '95%',
        maxWidth: '95%',
        title:function(){
            return $(this).attr('title');
        }
    });
})(jQuery);
